// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"3686": "6d0ff0693fb6","3993": "3f525799a689","6374": "b291ea6f3692","8755": "c7bd4b6c2a25",}[chunkId] + ".css"
}